(function () {
  if (isEmbedded()) {
    const params = new URLSearchParams(globalThis.location.search);
    const wlParam = params.get('wl');

    let config = null;

    if (wlParam) {
      try {
        const decoded = atob(wlParam);
        config = JSON.parse(decoded);
      } catch (error) {
        console.error('Failed to parse whitelabel config from URL:', error);
      }
    }

    if (!config) {
      displaySplashScreenLogo();

      return;
    }

    if (config.brand) {
      document.title = config.brand;
    }

    if (config.hideLogo) {
      let favicon = document.querySelector('link[rel="icon"]');

      if (favicon) {
        favicon.href = null;
      }
    }

    if (config.splashImg) {
      const splashImage = document.querySelector('.splash-screen-logo');

      if (splashImage) {
        splashImage.src = config.splashImg;
      }
    }
  }

  displaySplashScreenLogo();

  function isEmbedded() {
    try {
      return window.self !== window.top;
    } catch {
      return true;
    }
  }

  function displaySplashScreenLogo() {
    document.querySelector('.splash-screen-logo').classList.add('splash-screen-logo-ready');
  }
})();
